import listComponent from '@/util/proto/listComponent'
import View from './view'
import TimeRange from '../partial/time-range'
import CompanySelect from '../partial/company-select'
import { saveFile } from '@/util'
import Chart from '../partial/chart'
import LicenseSelect from '../../license/partial/license-select'
export const onlineRate = (d) => {
  let val = ( !d.carOnlineNum || !d.carWorkNum ) ? 0 : d.carWorkNum / d.carOnlineNum
  d.onlineRateValue = val
  return Math.floor(100 * val) + '%'
}
export default {
  extends: listComponent,
  mixins: [global],
  data() {
    return {
      columns: [{
          title: '序号',
          type: 'index',
          align: 'center',
          width: 60,
        },
        {
          title: '快递品牌',
          key: 'brandName',
          minWidth: 150,
        },
        {
          title: '网点总数',
          key: 'companyTotal',
          minWidth: 100,
        },
        {
          title: '人员总数',
          key: 'courierTotal',
          minWidth: 100,
        },
        {
          title: '车辆总数',
          key: 'carTotal',
          minWidth: 100,
        },
        {
          title: '工作总数',
          key: 'carWorkNum',
          minWidth: 100,
        },
        {
          title: '休息车辆',
          key: 'carRestNum',
          minWidth: 100,
        },
        {
          title: '工作效率',
          key: 'onlineRate',
          minWidth: 100,
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: "right",
          align: 'center',
          render: (h, { row }) => {

            let acts = [
              <a on-click={()=>this.view(row)}>查看</a>,
            ]

            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],

      chartData: [],

      cache:null,

      params: {
        companyName: null,
        districtCode:null,
      },
      chartVisible: false,
      loading: false
    }
  },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search(reload) {
      let search = this.params

      let params = { search, pageSize: this.page.pageSize, pageNum: this.page.pageNum, orders: this.page.orders }

      this.loading = true

      if( reload ) this.cache = null

      this.getData(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [])
          this.convChartData(this.data)
          this.page.total = resp.data.total || 0
        }
      })
    },

    getData(params){
      let { pageNum = 1, pageSize } = params

      return Promise.resolve(this.cache || this.$request.statsBrands(params.search)).then( resp => {
        if( !this.cache ) {
          if( resp.data ){
            this.$utils.conv(resp.data , { onlineRate }).sort((a,b) => a.onlineRateValue < b.onlineRateValue ? 1 : -1)
          }
          this.cache = resp
        }

        return Promise.resolve( {
          code:0,
          data:{
            list:this.cache.data.slice((pageNum-1)*pageSize , (pageNum)*pageSize),
            total:this.cache.data.length
          }
        })
      })
    },
    //查看
    view(row) {
      let { rangeTime } = this.params
      let params = {
        brandId :row.brandId,
      }
      this.$refs['itemView'].init(params)
    },

    reset() {
      for (let i in this.params) {
        this.params[i] = null
      }
      this.search(true)
    },
    handleExport() {
      let { ...options } = this.params

      this.$request.statsCompanyViolationExport(options).then(resp => {
        saveFile(resp)
      })
    },
    handleChangeTime(v) {
      this.search()
    },
    convChartData(d) {
      console.log(d)
      let ret = [],
        props = [
          ['onlineRateValue', '工作效率'],
        ]
      for (let i of d) {
        for (let j of props) {
          ret.push({ label: i.brandName, value: i[j[0]] || 0, type: j[1] })
        }
      }
      this.chartData = ret
    }
  },
  render() {
    const { params } = this
    const chartNode = this.chartVisible ? <Chart data={this.chartData} percent={true} /> : null
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={() => this.search(true)} on-reset={this.reset}>
            <sl-search-item label="">
              <sl-select v-model={params.brandId} dict="brand" filterable={true} placeholder="快递品牌" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-area v-model={params.districtCode} data-type="code" placeholder="所属区域" />
            </sl-search-item>
            <template slot="action">
              <div>
                <i-switch size="small" style="margin-right:5px;" v-model={this.chartVisible}></i-switch>
                <span>显示图表</span>
              </div>
            </template>
          </sl-search>
        </div>
        <div class="pg-bd">
          { chartNode }
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <View ref="itemView" />
      </sl-page>
    )
  }
}
